import * as PIXI from "pixi.js";
import gsap from "gsap";
import MyApplication from "../../../pixi/MyApplication";
import AssetsManager from "../../../pixi/AssetsManager";

export enum PANDA_LABEL {
  LABEL_STAND,
  LABEL_WALK,
  LABEL_JET,
  LABEL_HIT,
}

/**
 * PandaViewクラス
 */
class PandaView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //影
  private _shadow: PIXI.Sprite;

  //コンテナ
  private _container: PIXI.Container;

  //パンダ
  private _pandaContainer: PIXI.Container;
  private _standMc: PIXI.AnimatedSprite;
  private _walkMc: PIXI.AnimatedSprite;
  private _jetMc: PIXI.AnimatedSprite;
  private _hitMc: PIXI.AnimatedSprite;

  //ファイヤー
  private _normalFire: PIXI.AnimatedSprite;
  private _strongFire: PIXI.AnimatedSprite;

  //パンダの本体参照
  public get panda(): PIXI.DisplayObject {
    return this._container;
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	PandaView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor(shadowFlag: boolean = true) {
    super();

    //アセットマネージャー
    const assetsManager: AssetsManager = AssetsManager.instance;

    //影
    if (shadowFlag) {
      this._shadow = assetsManager.createSpriteByName("panda_shadow.png");
      this._shadow.anchor.set(0.5);
      this._shadow.scale.set(4);
      this._shadow.alpha = 0.3;
      this._shadow.y = -4;
      this._shadow.x = 12;
      this.addChild(this._shadow);
    }

    //コンテナ
    this._container = new PIXI.Container();
    this.addChild(this._container);
    this._pandaContainer = new PIXI.Container();
    this._pandaContainer.scale.set(4);
    this._container.addChild(this._pandaContainer);

    //ステイ
    this._standMc = assetsManager.createMovieClipFromAnimation("panda_stand");
    this._standMc.anchor.set(0.5, 1);
    this._pandaContainer.addChild(this._standMc);

    //歩く
    this._walkMc = assetsManager.createMovieClipFromAnimation("panda_walk");
    this._walkMc.anchor.set(0.5, 1);
    this._pandaContainer.addChild(this._walkMc);

    //ジェット
    this._jetMc = assetsManager.createMovieClipFromAnimation("panda_jet");
    this._jetMc.anchor.set(0.5, 1);
    this._pandaContainer.addChild(this._jetMc);

    //ヒット
    this._hitMc = assetsManager.createMovieClipFromAnimation("panda_hit");
    this._hitMc.anchor.set(0.5, 1);
    this._pandaContainer.addChild(this._hitMc);

    //普通のほのを
    this._normalFire =
      assetsManager.createMovieClipFromAnimation("fire_normal");
    this._normalFire.scale.set(4);
    this._normalFire.animationSpeed = 20 / 60;
    this._normalFire.play();
    this._normalFire.x = -this._standMc.width * 2 - 20;
    this._normalFire.y = -this._standMc.height * 4 + 32;
    this._container.addChild(this._normalFire);

    //強いのほのを
    this._strongFire =
      assetsManager.createMovieClipFromAnimation("fire_strong");
    this._strongFire.scale.set(4);
    this._strongFire.animationSpeed = 20 / 60;
    this._strongFire.play();
    this._strongFire.x = this._normalFire.x;
    this._strongFire.y = this._normalFire.y;
    this._container.addChild(this._strongFire);

    //リセット
    this.reset();
  }

  /**
   * リセット
   */
  reset(): void {
    //Tween停止
    gsap.killTweensOf(this);

    //初期状態へ
    this.gotoAndPlay(PANDA_LABEL.LABEL_STAND);

    //Y座標
    this._container.y = 0;

    //ほのお
    this._normalFire.visible = false;
    this._strongFire.visible = false;
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	Action
  // ---------------------------------------------------------------------------------------------------------

  /**
   * アニメーション再生
   */
  public gotoAndPlay(
    label: PANDA_LABEL,
    loop: boolean = true,
    fps: number = 0
  ): void {
    let len = this._pandaContainer.children.length;
    for (let i = 0; i < len; i++) {
      //mc参照
      const mc: PIXI.AnimatedSprite = this._pandaContainer.getChildAt(
        i
      ) as PIXI.AnimatedSprite;

      //表示
      if (i == label) {
        mc.visible = true;
        if (fps > 0) {
          mc.loop = loop;
          mc.animationSpeed = fps / 60;
          mc.gotoAndPlay(0);
        } else {
          mc.gotoAndStop(0);
        }
      }
      //非表示
      else {
        mc.stop();
        mc.visible = false;
      }
    }

    //炎表示
    if (label == PANDA_LABEL.LABEL_JET) {
      this._normalFire.visible = true;
      this._strongFire.visible = false;
    }
    //炎非表示
    else {
      this._normalFire.visible = false;
      this._strongFire.visible = false;
    }
  }

  /**
   * 停止
   */
  public stop(): void {
    let len = this._pandaContainer.children.length;
    for (let i = 0; i < len; i++) {
      //mc参照
      const mc: PIXI.AnimatedSprite = this._pandaContainer.getChildAt(
        i
      ) as PIXI.AnimatedSprite;

      //アニメーション止める
      mc.stop();
    }
  }

  /**
   * 火力アップ
   */
  public powerUp(): void {
    this._normalFire.visible = false;
    this._strongFire.visible = true;
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default PandaView;
